export class CardImage {
  id: number;
  type: ImageType;
  src: string;
  hasLink: boolean = false;
  linkImage: string = '';
  draggable: boolean;
  resizable: boolean;
  width: number;
  height: number;
  x: number;
  y: number;
  xPos: number = 0;
  yPos: number = 0;
  wPos: number = 0;
  hPos: number = 0;

  hadValsSet: boolean = false;
  uploaded: boolean;
  textSetup: CardText;
  textResized: boolean = false; //For editing reference
  hasKonvaImage: boolean = false;
  hasKonvaGroup: boolean = false;
  imageSave: any = null;
  groupSave: any = null; //For editing reference
  aspectRatio: number = 1;

  multiTouch: boolean = false;
  touchAtStart: any = {};
  tempX: number = 0;
  tempY: number = 0;
  tempW: number = 0;
  tempH: number = 0;

  hasFormatAnchorsAdded: boolean = false;
  hasCropAnchorsAdded: boolean = false;
  TLFAnchor = null;
  addedTLFAnchor = false;
  TRFAnchor = null;
  addedTRFAnchor = false;
  BLFAnchor = null;
  addedBLFAnchor = false;
  BRFAnchor = null;
  addedBRFAnchor = false;
  TLCAnchor = null;
  addedTLCAnchor = false;
  TRCAnchor = null;
  addedTRCAnchor = false;
  BLCAnchor = null;
  addedBLCAnchor = false;
  BRCAnchor = null;
  addedBRCAnchor = false;


  constructor(id: number, type: ImageType, src: string, draggable: boolean, resizable: boolean,
    width: number, height: number, x: number, y: number, uploaded: boolean, textSetup: CardText) {
    this.id = id;
    this.type = type;
    this.src = src;
    this.draggable = draggable;
    this.resizable = resizable;
    this.width = width;
    this.height = height;
    this.x = x;
    this.y = y;
    this.uploaded = uploaded;
    this.textSetup = textSetup;
    this.aspectRatio = height / width;
  }
}

export enum ImageType {
  image = "image",
  text = "text"
}

export class CardText {
  text: string;
  fontSize: number;
  font: string;
  color: string;
  shape: TextShape;
  extraHeight: number;
  extraWidth: number;
  shapeColor: string;
  borderColor: string;
  borderWidth: number;
  templateText: boolean;

  constructor(text: string, fontSize: number, font: string, color: string, shape: TextShape, shapeColor: string, borderColor: string,
              borderWidth: number, extraHeight: number, extraWidth: number, templateText: boolean = false) {
    this.text = text;
    this.fontSize = fontSize;
    this.font = font;
    this.color = color;
    this.shape = shape;//TextShape.CIRCLE;
    this.shapeColor = shapeColor;//'#12F163';
    this.borderColor = borderColor;//'#F16D12';
    this.borderWidth = borderWidth;//2;
    this.extraHeight = extraHeight;//10;
    this.extraWidth = extraWidth;//10;
    this.templateText = templateText;
  }
}

export enum TextShape {
  NONE = 0,
  SQUARE = 1,
  CIRCLE = 2
}
